module.exports = __webpack_public_path__ + "static/404_bg.a1c43ee0.png";